// Tỉnh/Thành → Phường/Xã cascading selects on the checkout page.
// Backed by a static bundled dataset (assets/data/vn-address.json) — no live API.
// 2-tier since the 2025 administrative reform (effective 01/07/2025) abolished
// the district (Quận/Huyện) level entirely.
function populateSelect(select, items, placeholder) {
	select.innerHTML = '';

	const placeholderOption = document.createElement('option');
	placeholderOption.value = '';
	placeholderOption.textContent = placeholder;
	select.appendChild(placeholderOption);

	items.forEach((item) => {
		const option = document.createElement('option');
		option.value = item.code;
		option.textContent = item.name;
		select.appendChild(option);
	});

	select.disabled = items.length === 0;
}

document.addEventListener('DOMContentLoaded', () => {
	const provinceSelect = document.getElementById('checkout-province');
	if (!provinceSelect) {
		return;
	}

	const wardSelect = document.getElementById('checkout-ward');

	fetch(provinceSelect.dataset.addressUrl)
		.then((res) => res.json())
		.then((tree) => {
			tree.forEach((province) => {
				const option = document.createElement('option');
				option.value = province.code;
				option.textContent = province.name;
				provinceSelect.appendChild(option);
			});

			provinceSelect.addEventListener('change', () => {
				const province = tree.find((p) => p.code === provinceSelect.value);
				populateSelect(wardSelect, province ? province.wards : [], 'Chọn Phường/Xã');
			});
		});
});
